<script>
import { swal } from "../../../helpers/handle_error.js";
import { required, minLength, maxLength } from "vuelidate/lib/validators";

import relative_relation from "../../../helpers/list/relative_relation";
import gender from "../../../helpers/list/gender";

export default {
  components: {},
  props: {},
  data() {
    return {
      fields: [],

      //lists
      list_relative_relation: relative_relation,
      list_gender: gender,
    };
  },
  validations: {
    fields: {
      $each: {
        name1: { required, minLength: minLength(2), maxLength: maxLength(15) },
        name2: { required, minLength: minLength(2), maxLength: maxLength(15) },
        name3: { required, minLength: minLength(2), maxLength: maxLength(15) },
        name4: { required, minLength: minLength(2), maxLength: maxLength(15) },
        gender_id: { required },
        relative_relation_id: { required },
      },
    },

    form: ["fields"],
  },
  methods: {
    //  Push the row in form
    AddformDataS() {
      this.fields.push({
        name1: "",
        name2: "",
        name3: "",
        name4: "",
        relative_relation_id: "",
        gender_id: "",
      });
    },
    // Delete the row
    async deleteRowS(index) {
      if (await swal.confirm()) {
        this.fields.splice(index, 1);
        this.list_health_status_family.splice(index, 1);
      }
    },
    // validate
    validate() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid;
      this.$emit("on-validate", this.$data, isValid);
      return isValid;
    },

    chnageFile(e) {
      e = e.target;
      let index = e.getAttribute("data-index");
      this.fields[index][e.id] = e.files.length > 0 ? e.files[0] : null;
    },
  },
  created() {
    this.AddformDataS();
  },
};
</script>

<template>
  <!-- start page title -->
  <div>
    <div class="row">
      <hr class="hr-title" />
      <div class="break-title"><h5 class="mb-4">معلومات عائلة الجريح</h5></div>
      <ul class="li-attachments">
        <li>يجب ادخال معلومات افراد العائلة للجريح .</li>
      </ul>

      <form class="repeater" enctype="multipart/form-data">
        <div v-for="(field, index) in $v.fields.$each.$iter" :key="field.id" class="">
          <div class="row">
            <b-form-group class="col-md-3 mb-3" label="الاسم : " label-for="name1">
              <b-form-input
                id="name1"
                type="text"
                placeholder="ادخل الاسم"
                v-model.trim="field.name1.$model"
                :class="{ 'is-invalid': field.name1.$error }"
              ></b-form-input>
              <div v-if="field.name1.$error" class="invalid-feedback">
                <span v-if="!field.name1.required">هذا الحقل الزامي</span>
                <span v-if="!field.name1.minLength"
                  >يجب أن يتكون الاسم من حرفين على الأقل</span
                >
                <span v-if="!field.name1.maxLength"
                  >يجب أن يتكون الاسم من 15 حرف على الاكثر</span
                >
              </div>
            </b-form-group>
            <b-form-group class="col-md-3 mb-3" label="اسم الاب : " label-for="name2">
              <b-form-input
                id="name2"
                type="text"
                placeholder="ادخل اسم الاب"
                v-model.trim="field.name2.$model"
                :class="{ 'is-invalid': field.name2.$error }"
              ></b-form-input>
              <div v-if="field.name2.$error" class="invalid-feedback">
                <span v-if="!field.name2.required">هذا الحقل الزامي</span>
                <span v-if="!field.name2.minLength"
                  >يجب أن يتكون الاسم من حرفين على الأقل</span
                >
                <span v-if="!field.name2.maxLength"
                  >يجب أن يتكون الاسم من 15 حرف على الاكثر</span
                >
              </div>
            </b-form-group>
            <b-form-group class="col-md-3 mb-3" label="اسم الجد : " label-for="name3">
              <b-form-input
                id="name3"
                type="text"
                placeholder="ادخل اسم الجد"
                v-model.trim="field.name3.$model"
                :class="{ 'is-invalid': field.name3.$error }"
              ></b-form-input>
              <div v-if="field.name3.$error" class="invalid-feedback">
                <span v-if="!field.name3.required">هذا الحقل الزامي</span>
                <span v-if="!field.name3.minLength"
                  >يجب أن يتكون الاسم من حرفين على الأقل</span
                >
                <span v-if="!field.name3.maxLength"
                  >يجب أن يتكون الاسم من 15 حرف على الاكثر</span
                >
              </div>
            </b-form-group>
            <b-form-group class="col-md-3 mb-3" label="اسم اب الجد : " label-for="name4">
              <b-form-input
                id="name4"
                type="text"
                placeholder="ادخل اسم اب الجد"
                v-model.trim="field.name4.$model"
                :class="{ 'is-invalid': field.name4.$error }"
              ></b-form-input>
              <div v-if="field.name4.$error" class="invalid-feedback">
                <span v-if="!field.name4.required">هذا الحقل الزامي</span>
                <span v-if="!field.name4.minLength"
                  >يجب أن يتكون الاسم من حرفين على الأقل</span
                >
                <span v-if="!field.name4.maxLength"
                  >يجب أن يتكون الاسم من 15 حرف على الاكثر</span
                >
              </div>
            </b-form-group>
          </div>
          <div class="row">
            <b-form-group class="col-md-6 mb-3" label=" الجنس : " label-for="gender_id">
              <select
                class="form-control"
                id="gender_id"
                v-model.trim="field.gender_id.$model"
                :class="{ 'is-invalid': field.gender_id.$error }"
              >
                <option value="">اختر الجنس</option>
                <option v-for="gender in list_gender" :value="gender.id" :key="gender.id">
                  {{ gender.name }}
                </option>
              </select>
              <div v-if="field.gender_id.$error" class="invalid-feedback">
                <span v-if="!field.gender_id.required">هذا الحقل الزامي</span>
              </div>
            </b-form-group>
            <b-form-group
              class="col-md-6 mb-3"
              label=" صلة القرابة من مقدم الطلب : "
              label-for="relative_relation_id"
            >
              <select
                class="form-control"
                id="relative_relation_id"
                v-model.trim="field.relative_relation_id.$model"
                :class="{ 'is-invalid': field.relative_relation_id.$error }"
              >
                <option value="">اختر صلة القرابة من مقدم الطلب</option>
                <option
                  v-for="relative_relation in list_relative_relation"
                  :value="relative_relation.id"
                  :key="relative_relation.id"
                >
                  {{ relative_relation.name }}
                </option>
              </select>
              <div v-if="field.relative_relation_id.$error" class="invalid-feedback">
                <span v-if="!field.relative_relation_id.required">هذا الحقل الزامي</span>
              </div>
            </b-form-group>
          </div>

          <div class="row">
            <b-form-group
              class="col-md-12 mb-3"
              label=" حذف :"
              label-for=""
              v-if="fields.length > 1"
            >
              <div class="d-grid">
                <button
                  type="button"
                  class="btn btn-danger btn-block"
                  @click="deleteRowS(index)"
                >
                  <i class="bx bx-trash font-size-16 align-middle"></i>
                </button>
              </div>
            </b-form-group>

            <div class="col-lg-12"><hr class="mt-0" /></div>
          </div>
        </div>
        <input
          type="button"
          class="btn btn-primary mt-3 mb-3 mt-lg-0"
          style="width: 100%"
          value="اضافة فرد اخر"
          @click="AddformDataS"
        />
      </form>
    </div>
  </div>
  <!-- end page title -->
</template>
